export default __webpack_public_path__ + "static/media/SelfStudy.f39a86d8fc32ca8fab8f1c83f2b266e2.webp";